import { UserCircleIcon, UserGroupIcon } from "@heroicons/react/24/solid";
import { PERMISSIONS, ROUTE_PATHS } from "../../PermissionsConstants";
import UserManagement from "./UsersManagement";
import RolesMgmt from "./RolesManagement";
export const UserManagementTabs = [
  {
    to: ROUTE_PATHS.Utilities_UserManagement_Index,
    icon: <UserCircleIcon className="h-4 w-4 float-left mr-2 " />,
    title: "User Management",
    component: UserManagement,
    permission: PERMISSIONS.permission_utilities_userrolemanagement_view,
  },
  {
    to: ROUTE_PATHS.Utilities_RoleSetting_Index,
    icon: <UserGroupIcon className="h-4 w-4 float-left mr-2 " />,
    title: "Roles Management",
    component: RolesMgmt,
    permission:
      PERMISSIONS.permission_utilities_userrolemanagement_management_view,
  },
];
